const stateKeyPrefix = 'intercept-back-button';

export default function interceptBackButton(callback) {
  if (!window.history) {
    // Let's have a failsafe for when the history object is missing.
    return () => { };
  }
  // Make a copy of the previous state key.
  const previousStateJson = JSON.stringify(history.state);
  const specialStateKey =
    stateKeyPrefix + Math.random().toString(36).substring(2) + Date.now();
  const specialState = { key: specialStateKey };
  const specialStateJson = JSON.stringify(specialState);
  const handler = (e) => {
    if (JSON.stringify(e.state) === previousStateJson) {
      // Back button triggered.
      callback();
    }
    window.removeEventListener('popstate', handler);
  };
  history.pushState(specialState, /* title= */'');
  window.addEventListener('popstate', handler);
  // History.back() is asynchronous. When calling history.back(),
  // cancelSpecialState returns a Promise that will resolve with the next
  // popstate event, which with some luck will be the popstate event triggered
  // by history.back() call. When not calling history.back(), a Promise is also
  // returned, but it resolves to undefined.
  // This way you can simply `await cancelSpecialState()` and then assume the
  // history was updated.
  // As per https://developer.mozilla.org/en-US/docs/Web/API/History/back
  // > This method is asynchronous. Add a listener for the popstate event in
  // > order to determine when the navigation has completed.
  return function cancelSpecialState() {
    // Remove the handler in case it's still registered.
    window.removeEventListener('popstate', handler);
    // Get back from the special state if we are still in it.
    if (JSON.stringify(history.state) === specialStateJson) {
      history.back();
      return new Promise((resolve) => {
        const backDoneHandler = (e) => {
          resolve(e);
          window.removeEventListener('popstate', backDoneHandler);
        };
        window.addEventListener('popstate', backDoneHandler);
      });
    }
    return Promise.resolve(undefined);
  };
}
